<mat-form-field appearance="outline" *ngIf="view === 'data' || view === 'fill'">
    <mat-label>{{ field?.label }}</mat-label>
    <input matInput
        id=""
        type="text"
        [ngModel]="value"
        (ngModelChange)="updateValue($event)"
        [minlength]="minLength"
        [maxlength]="maxLength"
        [required]="required"
        [readonly]="view === 'data'"
    />
    <mat-error *ngIf="error">{{error}}</mat-error>
</mat-form-field>

<div class="edit" *ngIf="view === 'edit'">

    <mat-checkbox
        [ngModel]="required"
        (ngModelChange)="updateRequired($event)"
    >Requis</mat-checkbox>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Taille minimale</mat-label>
        <input matInput
            id=""
            type="number"
            [ngModel]="minLength"
            (ngModelChange)="updateMinLength($event)"
        />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Taille maximale</mat-label>
        <input matInput
            id=""
            type="number"
            [ngModel]="maxLength"
            (ngModelChange)="updateMaxLength($event)"
        />
    </mat-form-field>

</div>
